<template>
  <div id="purchase-list-list-view" class="datatable-container">
    <vs-table ref="table" :data="purchases">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4">
        <div class="flex flex-wrap-reverse  data-list-btn-container">
          <date-picker v-model="dateRange" range class="mr-2"></date-picker>

          <vs-select v-model="status">
            <vs-select-item
              :key="`select${index}`"
              :value="item.value"
              :text="item.label"
              v-for="(item, index) in statusOptions"
            />
          </vs-select>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="userName">Transaction Date</vs-th>
        <vs-th sort-key="name">Product</vs-th>
        <vs-th sort-key="phone">Price</vs-th>
        <vs-th sort-key="status">Username</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td> {{ tr.transactionDate }} <br /> </vs-td>

            <vs-td>
              <p>{{ tr.description }}</p>
            </vs-td>

            <vs-td> {{ tr.wallet.balance.currency }} {{ tr.amount }} </vs-td>

            <vs-td> {{ tr.wallet.username }}<br /> </vs-td>

            <vs-td>
              <vs-chip :color="getStatusColor(tr.status)">
                {{ tr.status }}
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <!--prettier-ignore-->
              <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="$router.push({
                    name: 'purchase-detail',
                    params: { id: tr.id },
                })" />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <Pagination :total="totalPage" v-model="currentPage" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from '@/components/Pagination';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/en';

export default {
  components: {
    Pagination,
    DatePicker,
  },
  data() {
    return {
      dateRange: [],
      type: 'PURCHASE',
      status: '',
      itemsPerPage: 5,
      currentPage: 1,
      pageTotal: 0,
      totalItem: 0,
      totalPage: 0,
    };
  },
  computed: {
    ...mapState({
      purchases: ({ purchase }) => purchase.purchases,
    }),
    statusOptions() {
      return [
        { label: 'ALL', value: '' },
        { label: 'CREATED', value: 'CREATED' },
        { label: 'PROCESSING', value: 'PROCESSING' },
        { label: 'SUCCEEDED', value: 'SUCCEEDED' },
        { label: 'FAILED', value: 'FAILED' },
        { label: 'CANCELLED', value: 'CANCELLED' },
        { label: 'EXPIRED', value: 'EXPIRED' },
        { label: 'REFUNDED', value: 'REFUNDED' },
      ];
    },
  },
  methods: {
    ...mapActions({
      _getPurchases: 'purchase/getPurchases',
    }),
    getStatusColor(status) {
      if (status === 'PROCESSING') return 'primary';
      if (status === 'CANCELLED') return 'danger';
      if (status === 'FAILED') return 'danger';
      if (status === 'SUCCEEDED') return 'success';

      return 'warning';
    },
    getPurchases(params) {
      this._getPurchases(params)
        .then(response => {
          this.currentPage = parseInt(response.headers['x-pagination-page']);
          this.pageTotal = parseInt(response.headers['x-pagination-count']);
          this.totalItem = parseInt(response.headers['x-pagination-total']);
          this.totalPage = parseInt(response.headers['x-pagination-page-count']);
        })
        .catch(err => {
          console.error({ err });
        });
    },
  },
  async mounted() {
    this.getPurchases({
      page: this.currentPage,
      limit: this.itemsPerPage,
      type: this.type,
    });
  },
  watch: {
    dateRange() {
      let params = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        type: this.type,
        since: this.dateRange[0],
        until: this.dateRange[1],
        status: this.status || undefined,
      };

      return this.getPurchases(params);
    },
    status() {
      let params = {
        page: this.currentPage,
        limit: this.itemsPerPage,
        type: this.type,
        status: this.status || undefined,
        since: this.dateRange.length > 0 ? this.dateRange[0] : undefined,
        until: this.dateRange.length > 0 ? this.dateRange[1] : undefined,
      };

      return this.getPurchases(params);
    },
    async currentPage(newValue, oldValue) {
      if (newValue !== oldValue) {
        let params = {
          page: this.currentPage,
          limit: this.itemsPerPage,
          type: this.type,
          status: this.status || undefined,
          since: this.dateRange.length > 0 ? this.dateRange[0] : undefined,
          until: this.dateRange.length > 0 ? this.dateRange[1] : undefined,
        };
        await this.getPurchases(params);
      }
    },
  },
};
</script>
<style lang="scss">
#purchase-list-list-view {
  .mx-input {
    height: auto;
    font-size: 1rem;
    line-height: 1.5;
    letter-spacing: 0.01rem;
    padding: 8px;
  }
}
</style>
